const STORAGE_KEY = 'ekyc-theme';

const MODE = Object.freeze({
  LIGHT: 'light',
  DARK: 'dark',
});

export default Object.freeze({
  MODE,
  STORAGE_KEY,
});
